import { PLAYER_SIZE } from '../../constants';
import KnightA from '../../assets/KnightA';
import KnightB from '../../assets/KnightB';
import { PlayerShield } from '../atoms/PlayerShield';

/**
 * The player character: directional sprite + optional block shield overlay.
 * Props: playerX, playerY, playerFrame, facingAngle, isMoving, isDashing, isInvincible, isShielded, isDodging
 */
export function PlayerEntity({ playerX, playerY, playerFrame, facingAngle, isMoving, isDashing, isInvincible, isShielded, isDodging }) {
  return (
    <div
      className={`player${isInvincible ? ' invincible' : ''}${isShielded ? ' shielded' : ''}${isDashing ? ' dashing' : ''}${isDodging ? ' dodging' : ''}`}
      style={{ transform: `translate3d(${playerX}px,${playerY}px,0)` }}
    >
      {/* Directional PNG sprite — picks correct image from facingAngle */}
      {playerFrame === 1
        ? <KnightB facingAngle={facingAngle ?? 0} size={PLAYER_SIZE} isMoving={!!isMoving} />
        : <KnightA facingAngle={facingAngle ?? 0} size={PLAYER_SIZE} isMoving={!!isMoving} />
      }
      {/* Block shield — 50 px SVG centred over the player during shieldUntil window */}
      {isShielded && <PlayerShield />}
    </div>
  );
}
